import { STATUS_EVENT_NAME } from '../uploadControlConfig';
import {
  getLocalFailedFileCount,
  getRemoteFailedFileCount,
  getTotalFailedFileCount
} from './statusSummaryCounts';
import {
  getOverallStatus,
  getReadyToSubmit
} from './statusSummaryDerivation';

export function buildStatusSummaryDetail({
  config,
  acknowledged,
  validationMessage,
  hasVirusDetected,
  completionSummary,
  mediaItems,
  totalSelectedBytes,
  localUploadingCount,
  localSelectedNotUploadedCount,
  pendingUploadCount,
  remoteStatusSummary
}) {
  const localFailedFileCount = getLocalFailedFileCount(completionSummary);
  const remoteFailedFileCount = getRemoteFailedFileCount(remoteStatusSummary);
  const totalFailedFileCount = getTotalFailedFileCount(localFailedFileCount, remoteFailedFileCount);
  const readyToSubmit = getReadyToSubmit(completionSummary, remoteFailedFileCount);
  const overallStatus = getOverallStatus(completionSummary, remoteFailedFileCount);
  const normalizedRemoteStatusSummary = remoteStatusSummary
    ? {
        ...remoteStatusSummary,
        uploadFailedFileCount: remoteFailedFileCount
      }
    : null;

  return {
    eventName: STATUS_EVENT_NAME,
    controlMode: config.controlMode ?? 'edit',
    applicationNumber: config.applicationNumber || '',
    caseId: config.caseId || '',
    acknowledged,
    validationMessage: validationMessage || '',
    hasVirusDetected,
    overallStatus,
    readyToSubmit,
    canUpload: completionSummary.canUpload,
    completedCount: completionSummary.completedCount,
    totalUploadFailedFileCount: totalFailedFileCount,
    pendingCount: completionSummary.pendingCount,
    totalSelectedCount: mediaItems.length,
    totalSelectedBytes,
    localUploadSummary: {
      uploadingCount: localUploadingCount,
      selectedNotUploadedCount: localSelectedNotUploadedCount,
      pendingUploadCount,
      uploadFailedFileCount: localFailedFileCount
    },
    remoteStatusSummary: normalizedRemoteStatusSummary,
    fileStatuses: completionSummary.itemSummaries ?? [],
    timestampUtc: new Date().toISOString()
  };
}
